// Mirrors the API's SlugHelper.GenerateSlug and SlugFormat: a slug is one clean segment of a storefront URL.
const POLISH: Record<string, string> = { ą: "a", ć: "c", ę: "e", ł: "l", ń: "n", ó: "o", ś: "s", ź: "z", ż: "z" };

export const SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;
export const SLUG_MESSAGE = "Slug może zawierać tylko małe litery bez polskich znaków, cyfry i pojedyncze myślniki";

/** "Żółta Łódź – Edycja 2026" → "zolta-lodz-edycja-2026" (Polish letters transliterated, not dropped). */
export const toSlug = (text?: string): string => {
  if (!text) return "";
  return text
    .toLowerCase()
    .replace(/[ąćęłńóśźż]/g, (ch) => POLISH[ch])
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};
